import { Bell } from 'lucide-react';
import { useSelector } from 'react-redux';
import { getUnreadCount } from '@mocks/bildirimler';

export default function NotificationBadge({ onClick, isOpen = false }) {
    const { role } = useSelector((state) => state.auth);
    const unreadCount = getUnreadCount(role);

    return (
        <div className="relative">
            {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-error text-white text-xs font-bold flex items-center justify-center rounded-full border-2 border-white">
                    {unreadCount > 99 ? '99+' : unreadCount}
                </span>
            )}
            <button
                type="button"
                onClick={onClick}
                className={`p-2 rounded-lg transition-colors ${isOpen
                    ? 'bg-primary text-white'
                    : 'text-text-secondary hover:bg-bg-tertiary hover:text-primary'
                    }`}
                aria-label="Bildirimler"
            >
                <Bell size={22} />
            </button>
        </div>
    );
}
